module.exports = __webpack_public_path__ + "static/media/circle_doA.52037401.svg";